import * as React from 'react';
import { PartStyle } from '~/Api/InfoCard';
export var Sentence = function (_a) {
    var sentence = _a.sentence;
    return (<p data-testid='infocard-content'>
		{sentence.parts.map(function (part, i) { return (<React.Fragment key={i}>
				{part.spaceBefore ? ' ' : null}
				{part.styles.has(PartStyle.bold) ? <strong>{part.value}</strong> : part.value}
			</React.Fragment>); })}
	</p>);
};
Sentence.displayName = 'InfoCard.Sentence';
